module.exports = __webpack_public_path__ + "img/beach-tsv2.eb906c3b.jpg";